import {i18n} from '@netx/core/i18n';
import {SYSTEM_ATTRIBUTE_LABELS} from '../locales';
import {attributes} from '../singletons';

// still used in the non ported over attribute selector (the multiselector)
// avialble in the attribute context now
export const getAttributeLabelFromId = (id: number) => {
	if (id === -1) return '';

	const attr = attributes.get(id);
	if (!attr) return `!${id} unknown!`;
	if (!attr.get('system')) return attr.get('name');
	return SYSTEM_ATTRIBUTE_LABELS[id] || i18n.t(`i18n.${attr.get('name')}`);
};
